import React from "react";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import Deniz from "../assets/denizsallakoglu.jpg";
import CreativeDesignSection1 from "../components/CreativeDesign/CreativeDesignSection1/CreativeDesignSection1";
import CreativeDesignSection2 from "../components/CreativeDesign/CreativeDesignSection2/CreativeDesignSection2";
import SoftwareSolutionsSection5 from "../components/SoftwareSolutions/SoftwareSolutionsSection5/SoftwareSolutionsSection5";
import CreativeDesignSection3 from "../components/CreativeDesign/CreativeDesignSection3/CreativeDesignSection3";
import CreativeDesignSection4 from "../components/CreativeDesign/CreativeDesignSection4/CreativeDesignSection4";
import SEO from "../components/SEO";

import { useTranslation } from "react-i18next";

const CreativeDesign = () => {
  const { t } = useTranslation("global");
  return (
    <>
      <SEO slug="CreativeDesign" />
      <Navbar />
      <CreativeDesignSection1 />
      <CreativeDesignSection2 />
      <SoftwareSolutionsSection5
        quote={t("pages.creative.quote")}
        author={t("pages.creative.author")}
        title={t("pages.creative.title")}
        profileImage={Deniz}
      />
      <CreativeDesignSection3 />
      <CreativeDesignSection4 />

      <Footer />
    </>
  );
};

export default CreativeDesign;
